import getFunctionData from "../../../utils/get-function-data";
import processSpaceSplit from "./process-space-split";
import setLevelMap from "./set-level-map";

/**
 * Process 2nd level values separated by the comma (`,`) represented by the `▏`
 * @param {String} value
 * @param {MainClassProps} main
 * @param {Map<String, any>} pure
 * @param {StorageItemDataProps} data
 * @param {Map<String, any>} info
 * @example `linear-gradient(17deg▏rgba(0▌255▌0▌.8)▏rgba(0▌255▌0▌0)▂70.71%)`
 */
const processCommaSplit = (value, main, pure, data, info) => {
  /** Check if the value is function */
  const fn = getFunctionData(value);

  const path = info.get("path");

  info.set("fn-data", fn);

  /** Get the parameters */
  const parameters = /** @type {String} */ (
    fn.get("is-fn") ? fn.get("parameters") : fn.get("name")
  );

  /** Check if property is a CSS function (rgba, polygon) */
  const isFn = /** @type {Boolean} */ (fn.get("is-fn"));

  /** Get function name. Otherwise set `0` (margin, opacity) */
  const name = /** @type {String} */ (isFn ? fn.get("name") : "0");

  /**
   * Split the 2nd level parameters by comma `,` represented by the `▏`
   * @example "0%▂1%▏calc(100%▄+▄10px)▂[2%✦md▹22.2%]▏30%▂100%▏9%▂100%"
   */
  const split = parameters?.split("▏") || [];

  /** @type {PropertyLevelProps} */
  const map = new Map([[name, new Map()]]);
  const mapName = map.get(name) || new Map();

  setLevelMap(mapName, split, ",", parameters, isFn, name, "comma");

  /** @type {Array<any>} */
  const mapValues = mapName.get("values");

  /** Value number */
  let number = 0;

  /** Loop trough all items splitted by the comma */
  for (const item of split) {
    info.set("path", `${path}>${number}(,)`);

    mapValues.push(processSpaceSplit(item, main, pure, data, info));

    ++number;
  }

  return map;
};

export default processCommaSplit;
